import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = process.env.REACT_APP_CURATED_BASE_URL;
const REACT_APP_CURATED_TOKEN = process.env.REACT_APP_CURATED_API_TOKEN

export const curatedBaseApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        headers: {
            authorization: `Bearer ${REACT_APP_CURATED_TOKEN}`
        }
    }),
    endpoints: () => ({}),
    reducerPath: "curated"
})